import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginContext } from "../login/LoginContext";
import axios from "axios";
import Swal from 'sweetalert2';
import { BaseUrlContext } from "../context/BaseUrlContext";

export const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
     const {logout, login, fetchLoginUserReports, handleLogin, handleLoginUserReports,tokenKey,setTokenKey } = useContext(LoginContext);
     const { BaseUrl } = useContext(BaseUrlContext);
    
      // const user = JSON.parse(localStorage.getItem("user"));
      const navigate = useNavigate();
      
      // const [allReports, setAllReports] = useState([]);
      const [userData, setUserData] = useState();
      const [reportOpen, setReportOpen] = useState(false);
      const [fileUrl, setFileUrl] = useState();
      const [fileName, setFileName] = useState();
      const [blobPath, setBlobPath] = useState("");
      const [allReports, setAllReports] = useState([]);
      const [reportName, setReportName] = useState("");
      const [reportNo, setReportNo] = useState("");
      const [patientName, setPatientName] = useState("");
      const [currentFilter, setCurrentFilter] = useState("notReviewed");
      const [users, setUsers] = useState();

      const [page, setPage] = useState(1);
      const [perPage, setPerPage] = useState(5);
      const [totalRows, setTotalRows] = useState(0);

        const fetchReports = async (filter) => {
          if(!BaseUrl) return;
          if(!tokenKey){
            navigate("/");
            return;
          }
          // const params = new URLSearchParams(window.location.search);
          // const token = params.get("token");
          // setTokenKey(token);
          // localStorage.setItem("tokenKey",token);
          // console.log("Token from URL:", token);
        try{
          let endpoint = "";
        if (filter === "reviewed") {
          endpoint = "get-user-reviewed-reports";
        } else if (filter === "notReviewed") {
          endpoint = "get-user-not-reviewed-reports";
        } else {
          endpoint = "get-user-reports";
        }
        
        // await axios.get(`${BaseUrl}api/auth/${endpoint}`, {
        // headers: { Authorization: `Bearer ${tokenKey}` }        
        // }).then((res)=>{
        //   // localStorage.setItem("allReports", JSON.stringify(res.data));
        //     setAllReports(res.data);
        //     // console.log(res.data, "Response Data12435");
        //     axios.get(`${BaseUrl}api/auth/get-user`, {
        //     headers: { Authorization: `Bearer ${tokenKey}` }
        //     }).then((res) => {
        //     localStorage.setItem("userData", JSON.stringify(res.data));
        //     setUserData(res.data);
        //     // console.log(res.data, "User Data Response");
        //     });
        // }) 

        try {
          const response = await axios.get(
            `${BaseUrl}api/auth/${endpoint}?page=${page - 1}&size=${perPage}`,
            {
              headers: { Authorization: `Bearer ${tokenKey}` }
            }
          );

          setAllReports(response.data?.content);
          setTotalRows(response.data?.totalElements);
          const userRes = await axios.get(`${BaseUrl}api/auth/get-user`, {
            headers: { Authorization: `Bearer ${tokenKey}` }
          });

          localStorage.setItem("userData", JSON.stringify(userRes.data));
          setUserData(userRes.data);

        } catch (error) {
          console.error("Error fetching reports:", error);
        }
      
        }
        catch (error) {
          console.error("Error fetching reports:", error);
        }
      }
      // useEffect(() => {
      //   // const savedInfo = localStorage.getItem("allReports");
      //   // if (savedInfo) {
      //   //   setAllReports(JSON.parse(savedInfo));
      //   // }
      //   const savedUser = localStorage.getItem("userData");
      //   if (savedUser) {
      //     setUserData(JSON.parse(savedUser));
      //   }
      //   const tokenKey = localStorage.getItem("tokenKey");
      //   if (tokenKey) {
      //     setTokenKey(tokenKey);
      //   }
      //   // fetchReports(currentFilter); 
      // },[currentFilter,setCurrentFilter,BaseUrl]);
      useEffect(() => {
        const savedUser = localStorage.getItem("userData");
        if (savedUser) {
          setUserData(JSON.parse(savedUser));
        }

        const storedToken = localStorage.getItem("tokenKey");
        if (storedToken) {
          setTokenKey(storedToken);
        }
      }, []);
      
      const handleLogout = () => {
        localStorage.removeItem("username");
        localStorage.removeItem("userData");
        localStorage.removeItem("allReports");    
        window.location.replace('/');
      };
        const handleDownload = (row) => {
          // axios.get(`http://localhost:8082/online_portal/api/files/download?blobPath=${row.reptFl.blobPath}`)
          // .then((res) => {
          //   console.log(res.data, "Response Data124356");
           
          // })
          axios.get(`${BaseUrl}api/files/download?blobPath=${row.reptFl.blobPath}`, {
            responseType: 'blob'
          })
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            // console.log(url, "Response Data1243569",link);
            link.href = url;
            link.setAttribute('download', row.reptFl?.originalName);
            document.body.appendChild(link);
            link.click();
            link.remove();
          });

        };

        const handleRowClicked = async (row) => {
          // console.log(row, "Row clickedsfd");
          setReportName(row.reptName);
          setReportNo(row.reptNo);
          setPatientName(row.mrdName);
          setReportOpen(true);
           try {
            const res = await axios.get(`${BaseUrl}api/files/view?blobPath=${row.reptFl.blobPath}`, {
                responseType: "blob",
                headers: { Authorization: `Bearer ${tokenKey}` }
            });
            const blob = new Blob([res.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            setFileUrl(url);
            setFileName(row.reptFl.originalName);
            await axios.put(`${BaseUrl}reports/updateReviewed?reptNo=${row.reptNo}`,{},{
              headers: { Authorization: `Bearer ${tokenKey}` }
            })
            .then((res) => {
              // console.log(res.data, "Response Data124356dagga");
              fetchReports(currentFilter);
            })  
            
        } catch (err) {
            // console.error("Failed to fetch file:", err);
        }
        };

        const handleDelete = async (row) => {
  const result = await Swal.fire({
    text: `Do you really want to delete "${row.reptNo}"?`,
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    confirmButtonColor: "#00ABEF",
    cancelButtonColor: "#6c757b",
    background: "#dceff7ff",
    color: "#1f2937",
    width: "400px",
    position: 'top', 
    customClass: {
      popup: "small-alert",
      confirmButton: "px-2 py-1 text-sm",
      cancelButton: "px-2 py-1 text-sm"
    }
  });

  if (result.isConfirmed) {
    try {
      await axios.delete(`${BaseUrl}reports/delete/${row.reptNo}`,{
        headers: { Authorization: `Bearer ${tokenKey}` }
      });
      setAllReports(prev => prev.filter((r) => r.reptNo !== row.reptNo));
    } catch (err) {
      // console.error("Delete error:", err);
    }
  }
};

    return (<DashboardContext.Provider value={{
         allReports, 
         setAllReports, 
         userData, 
         setUserData, 
         handleLogout,
         handleRowClicked,
         fetchReports,
         handleDownload,
         handleDelete,
         reportOpen,
         setReportOpen,
         fileUrl,
         setFileUrl,
         fileName,
         setFileName,
         blobPath,
         setBlobPath,
         reportName,
         setReportName,
         reportNo,
         setReportNo,
         patientName,
         setPatientName,
         tokenKey,
         setTokenKey,
         currentFilter,
         setCurrentFilter,
        users,
        setUsers,
        page, setPage,
        perPage, setPerPage,
        totalRows, setTotalRows,
    }}>{children}
        </DashboardContext.Provider>)
}